import React, { FC } from 'react';
import { ContainerLarge } from '../../components/base/grid';
import MyPost from '../../components/myPost/myShipments';
import pageWrapper from '../../hoc/pageWrapper';
import IMyShipmentsViewModel from '../../interfaces/myShipments/myShipments';

interface Props {
	page: IMyShipmentsViewModel;
}

const MyShipments: FC<Props> = ({ page }) => {
	return (
		<ContainerLarge>
			<MyPost page={page} />
		</ContainerLarge>
	);
};

export default pageWrapper(MyShipments);
